import React from 'react';

const LedgerPage = React.lazy(() => import('pages/Ledger/pages/ListPage'));
const GeneralLedgerPage = React.lazy(() => import('pages/GeneralLedger/pages/ListPage'));
const TrialBalancePage = React.lazy(() => import('pages/TrialBalance/pages/ListPage'));

const ledgerRoute = [
  {
    path: '/ledger',
    exact: true,
    name: 'Sổ nhật ký chung',
    function: 'LEDGER_VIEW',
    component: LedgerPage,
  },
  {
    path: '/general-ledger',
    exact: true,
    name: 'Sổ cái',
    function: 'LEDGER_VIEW',
    component: GeneralLedgerPage,
  },
  {
    path: '/trial-balance',
    exact: true,
    name: 'Bảng cân đối số phát sinh',
    function: 'LEDGER_VIEW',
    component: TrialBalancePage,
  },
];

export default ledgerRoute;
